import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { ICatalog } from '../../catalogs/models/catalogs.models';

// fetch all Wishlist
export const FetchAllWishlist = createAction('[ Wishlist ] - FetchAllWishlist');
export const FetchAllWishlistSuccess = createAction(
  '[ Wishlist ] - FetchAllWishlist Success',
  props<{ wishlist: APIResponse<ICatalog> }>()
);
export const FetchAllWishlistError = createAction('[ Wishlist ] - FetchAllWishlist Error');

// add To Wishlist
export const ToggleWishlist = createAction(
  '[ Wishlist ] - ToggleWishlist',
  props<{ id: number }>()
);
export const ToggleWishlistSuccess = createAction(
  '[ Wishlist ] - ToggleWishlist Success',
  props<{ wichlist: ICatalog }>()
);
export const ToggleWishlistError = createAction('[ Wishlist ] - ToggleWishlist Error');
